// extracted by mini-css-extract-plugin
module.exports = {"datetime":"AnalyticsDateTime_datetime__X-i3k"};